import { JetView } from 'webix-jet';
import { allpayments } from 'models/allpayments';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the table view for balance adjustments.
 * @extends JetView
 */
export default class tableBalanceAdjustmentsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable',
                            id: 'datatable',
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            select: true,
                            columns: [
                                {
                                    id: 'AdjustmentId',
                                    header: _('ID Ajuste'),
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'UserId',
                                    header: _('ID Usuario'),
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'UserName',
                                    header: _('Nombre Usuario'),
                                    width: 300,
                                    sort: 'int',
                                    hidden: !devConfig.getPermAction('sensitiveInformationNames', 'Add'), // Hides column based on permission
                                },
                                {
                                    id: 'TypeMovement',
                                    header: _('Tipo de movimiento'),
                                    width: 200,
                                    sort: 'int',
                                    template: function (obj) {
                                        return obj.TypeMovement === 'S'
                                            ? 'Salida'
                                            : obj.TypeMovement === 'E'
                                              ? 'Entrada'
                                              : obj.TypeMovement; // Maps movement type to display text
                                    },
                                },
                                {
                                    id: 'Value',
                                    header: _('Valor'),
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.numberFormat, // Formats value as a number
                                },
                                {
                                    id: 'CreationDate',
                                    header: _('Fecha creación'),
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'ExpirationDate',
                                    header: _('Fecha Expiración'),
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'OperatorId',
                                    header: _('Id operador'),
                                    width: 200,
                                    sort: 'int',
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Shows loading overlay before data load
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hides loading overlay after data load
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox);
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>', // Shows no data overlay if no records are found
                                    );
                                }
                            },
                            tooltip: true,
                            math: true,
                            loadahead: devConfig.getDefaultDataFetch(), // Sets data fetch configuration
                            pager: 'pagerA', // Sets the pager for the datatable
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._;
        grid = $$('datatable');
        var url = devConfig.geturlApi() + 'Report/GetLoyaltyBalanceAdjustments'; // API endpoint for fetching data
        var filter = '';
        this.on(this.app, 'balanceAdjustments:filter', (filterData) => {
            /**
             * Builds a query URL with filters applied.
             * @param {string} baseUrl - The base URL for the API request.
             * @param {Object} filters - The filters to apply to the request.
             * @returns {string} The constructed query URL.
             */
            function buildQueryUrl(baseUrl, filters) {
                const params = [];
                Object.entries(filters).forEach(([key, value]) => {
                    if (key.includes('Datepicker')) {
                        let date = value.split(' - ');
                        params.push(`dateFrom=${date[0]}&dateTo=${date[1]}`); // Adds date range to query parameters
                    } else if (value !== '') {
                        params.push(`${key}=${encodeURIComponent(value)}`); // Encodes and adds other filters
                    }
                });
                return `${baseUrl}&${params.join('&')}`; // Constructs the final URL
            }
            const queryUrl = buildQueryUrl(url + '?start=0&count=' + grid.data.$pagesize, filterData);
            grid.clearAll(); // Clears existing data in the grid
            grid.load(queryUrl); // Loads new data based on the constructed query URL
        });
    }
}

// FILE DOCUMENTED
